import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Grid, styled } from '@mui/material';
import { SideNavigation } from '../../components/molecules/SideNavigation';
const Container = styled(Grid) `
  display: flex;
  flex-direction: row;
  flex: 1;
  transition: margin-left .2s, width .2s;
`;
const WithDrawer = (props) => {
    const { children, onOpen, onClose, facility, workstation, facilitiesData, ...rest } = props;
    const [facilityLabel, setFacilityLabel] = useState();
    const [workstationLabel, setWorkstationLabel] = useState();
    useEffect(() => {
        const facilityData = facilitiesData.find(data => (data.value === Number(facility)));
        setFacilityLabel(facilityData?.label);
        const workstationData = facilityData?.workstations.find(data => (data.value === Number(workstation)));
        setWorkstationLabel(workstationData?.label);
    }, [facilitiesData, facility, workstation]);
    const handleDrawerOpen = () => {
        onOpen?.();
    };
    const handleDrawerClose = () => {
        onClose?.();
    };
    const drawer = (_jsx(SideNavigation, { onOpen: handleDrawerOpen, onClose: handleDrawerClose, facility: facilityLabel, workstation: workstationLabel, ...rest }));
    return (_jsxs(Container, { item: true, container: true, right: 0, children: [_jsx(Grid, { item: true, container: true, flex: 0, children: drawer }), _jsx(Grid, { item: true, container: true, flex: 1, flexDirection: 'column', width: '100%', children: children })] }));
};
export default WithDrawer;
//# sourceMappingURL=index.js.map